import { Link } from "react-router-dom";
import SEOHead from "../components/SEOHead";
import { Button } from "../components/ui/button";
import { useLanguage } from "../contexts/LanguageContext";

export default function NotFound() {
  const { t } = useLanguage();
  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center text-center px-4" data-testid="not-found-page">
      <SEOHead title={t("notfound.seo_title", "Page introuvable | Buy Likes and Followers")} noindex />
      <h1 className="font-heading text-6xl font-black text-white mb-4">404</h1>
      <p className="text-zinc-500 mb-8">{t("notfound.text", "Cette page n'existe pas.")}</p>
      <Link to="/"><Button className="rounded-full bg-indigo-500 hover:bg-indigo-600" data-testid="not-found-home-btn">{t("confirmation.back_home_btn", "Retour à l'accueil")}</Button></Link>
    </div>
  );
}
